module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';

	fox.registerWidget('UserPersonalData', {

		configure: function (options) {
			
			this.registerOptions('', {
				autoRender: false,
				'embed.container': '#user-personal-data',
                template: 'user_personal_data',
                widgets: {
                    updateApi: {
                        widget: 'Api',
                        method: 'consent.provideBulk',
                        httpMethod: 'post'
                    },
                    getSettingsApi: {
                        widget: 'Api',
                        method: 'consent.list'
                    }
                },
                handleDom: {
                    required: {
                        target: '.required-checkbox',
                        callback: '_showAttentionPopup'
                    },
                    change: {
                        target: '.communication-checkbox',
                        callback: '_change'
                    }
                }
			});

			this.callParent('configure', arguments);
		},

		running: function() {
            this.getSettings().then(this._renderData.bind(this));
            this.callParent('running', arguments);
		},

		getSettings: function() {
            return this.wom1('#getSettingsApi').psend({});
            // return fox.Promise.resolve({params: {answer: {response: {
            //     tos: 1,
            //     tosDate: new Date().getTime(),
            //     sestaFosta: 0,
            //     sestaFostaDate: new Date().getTime(),
            //     notifications: 1,
            //     marketing: 0
            // }}}});
        },
        
        _renderData: function(resp) {
            var data = resp.params.answer.response;

            data.timestamp *= 1000;
            
            this.setTemplateOptions(fox.merge(data, {modelName: fox.site.getEnv('screenName')})).render();
        },

        _showAttentionPopup: function(elm) {           
            fox.dom[(!elm.checked ? 'addClass' : 'removeClass')]('common-error-text-color', elm.parentNode.parentNode);
            
            if (!elm.checked) {

                this.showAttentionPopup().then(function(result) {
                    if (result === true) {
                        return;
                    }

                    fox.dom.removeClass('common-error-text-color', elm.parentNode.parentNode);
                    elm.checked = true;
                });

                return;
            }
        },

        showAttentionPopup: function() {
            return fox.site.rwom1('#gdprDeleteAccount').show()
        },

        _change: function(elm) {
            var elms = this.dom('input[type="checkbox"]');
            var data = {};

            fox.each(elms, function(elm) {
                data[elm.name] = Number(elm.checked);
            });

            return this.wom1('#updateApi')
                .psend({aliases: data});
        }

	}, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-personal-data/widget/userPersonalData.js
// module id = 555
// module chunks = 4